//Completed By Rabbil
import React, { Component} from "react";
import { Link } from "react-router-dom";
import { RetrieveFooter, StoreFooter } from "../../Helper/LocalForgeHelper";
import axios from "axios";
import { SiteInfoURL } from "../../APIServices/SiteInfoRequest";
import ReactHtmlParser from "react-html-parser";

import AppleStore from "../../Assets/Img/AppleStore.png";
import GoogleStore from "../../Assets/Img/GoogleStore.png";
import Payment from "../../Assets/Img/Payment.png";
import rajMangoLogo from "../../Assets/Img/mainlogo.svg";
class Footer extends Component {
  constructor() {
    super();
    this.state = {
      about: "",
      address: "",
      android: "",
      ios: "",
      facebook: "",
      youtube: "",
      twitter: "",
      instagram: ""
    };
  }
  componentDidMount() {
    this.SelectFooter();
  }
  SelectFooter = () => {
    RetrieveFooter((StoreData) => { 
      if (StoreData !== null) {
        this.setState({
          about: StoreData[0]["about_company"],
          address: StoreData[0]["address"],
          android: StoreData[0]["android_app_link"],
          ios: StoreData[0]["ios_app_link"],
          facebook: StoreData[0]["facebook_link"],
          instagram: StoreData[0]["instagram_link"],
          twitter: StoreData[0]["twitter_link"],
          youtube: StoreData[0]["youtube_link"],
        });
      } else {
        axios.get(SiteInfoURL()).then((res) => {
          this.setState({
            about: res.data[0]["about_company"],
            address: res.data[0]["address"],
            android: res.data[0]["android_app_link"],
            ios: res.data[0]["ios_app_link"],
            facebook: res.data[0]["facebook_link"],
            instagram: res.data[0]["instagram_link"],
            twitter: res.data[0]["twitter_link"],
            youtube: res.data[0]["youtube_link"],
          });
          StoreFooter(res.data); 
        });
      }
    });
  };

  render() {
    return (
      <>
        <div id="Footer" className="d-none d-sm-block">
          <div className="container">
            <div className="row">
              <div className="col-6 col-lg-3 text-start text-white">
                <div className="image text-start">
                  <img
                    height="100px"
                    src={rajMangoLogo}
                  />
                </div>
                <h5 className="mt-2 mb-2 ">আমােদর সম্পর্কে </h5>
                <div>{ReactHtmlParser(this.state.about)}</div>
                <div className="d-flex align-items-center">
                  <a
                    href={this.state.youtube}
                    target="_blank"
                    rel="noreferrer"
                    className="FooterIcon"
                  >
                    <i className="fa-brands fa-youtube"></i>
                  </a>
    
                  <a href={this.state.twitter} className="FooterIcon">
                    <i className="fa-brands fa-twitter"></i>
                  </a>
                  <a
                    href={this.state.facebook}
                    target="_blank"
                    rel="noreferrer"
                    className="FooterIcon"
                  >
                    <i className="fa-brands fa-facebook-f"></i>
                  </a>
                  <a href={this.state.instagram} className="FooterIcon">
                    <i className="fa-brands fa-instagram"></i>
                  </a>
                </div>
              </div>
              <div className="col-6 col-lg-3 text-start text-white">
                <div className="d-lg-none" style={{ height: 100 }}></div>
                <h4 className="mt-0 mt-lg-5 mb-2 mb-lg-5">আমাদের ঠিকানা</h4>
                <div className="lh-lg">{ReactHtmlParser(this.state.address)}</div>
              </div>
              <div className="col-6 col-lg-3 text-start">
                <h4 className="mt-5 mb-3 mb-lg-5 text-white">ইনফরমেশন</h4>
                <ul className="navbar-nav">
                  <li className="nav-item">
                    <Link
                      className="pt-0 nav-link text-white"
                      to="/HowPurchase"
                    >
                      কিভাবে কিনবেন
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link text-white" to="/About">
                      আমাদের সম্পর্কে
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link text-white" to="/Contact">
                      যোগাযোগ
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link text-white" to="/Privacy">
                      প্রাইভেসি পলিসি
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link text-white" to="/Terms">
                      শর্ত সমুহ
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link text-white" to="/Refund">
                      ফেরত নীতি
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="col-6 col-lg-3 p-0">
                <div className="d-flex flex-column flex-lg-row mt-5 mb-3 mb-lg-5  align-items-lg-center">
                  <div
                    style={{ marginRight: 15 }}
                    className="d-flex text-white align-items-center"
                  >
                    <i
                      style={{ marginRight: "5px", fontSize: "25px" }}
                      className="fa-solid fa-headphones-simple"
                    ></i>
                    <h5 className="mt-3 ml-2"> <a className="text-white text-decoration-none" href="tel:+8801707979767"> +8801707979767</a> </h5>
                  </div>
                  <a className="btn btn-outline-white mt-3 mt-lg-0 text-uppercase">
                    Live Chat
                  </a>
                </div>
                <div className="row">
                  <div className="col-6">
                    <a href={this.state.ios} target="_blank"
                    rel="noreferrer">
                      <img className="img-fluid" src={AppleStore} />
                    </a>
                  </div>
                  <div className="col-6">
                    <a href={this.state.android} target="_blank"
                    rel="noreferrer">
                    <img className="img-fluid" src={GoogleStore} />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="MobileFooter d-block d-sm-none">
          <div className="container">
            <div className="d-flex justify-content-sm-center align-items-center flex-column p-2">
              <p className="pt-2">
                &copy; সর্বস্বত্ব সংরক্কিত ২০২১-২০২৩ রাজশাহীর আম
              </p>
              <img className="img-fluid" src={Payment} />
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default Footer;
